import {AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';
import { AppService } from 'app/services/app.service';
import { Subscription } from 'rxjs';
import ListForIntegrationsViewConfig from 'app/configs/datasets/domain_packages/list_for_integrations.view_config';
import { StepService } from 'app/main/components/dataset/services/step-state.service';
import widgetFormField from "../widgetFormField";
import websiteFormConfig from "../websiteFormConfig";
import {FormViewerComponent} from "../../../../../form-viewer/form-viewer.component";
import {FormViewerService} from "../../../../../../../services/form-viewer.service";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WidgetDialogComponent } from '../widget-dialog.component';

@Component({
    selector: 'integration-block',
    templateUrl: './integration-block.component.html',
    styleUrls: ['./integration-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IntegrationBlockComponent implements OnInit, OnChanges{
	
	@Output() reload: EventEmitter<void|any> = new EventEmitter();
	@Output() updated: EventEmitter<any> = new EventEmitter();
	@Output() create: EventEmitter<void> = new EventEmitter();
	@Input() tourOperator: any = {};

	widgetForm = widgetFormField;
	websiteFormData = {};
	websiteForm = websiteFormConfig;

	loading = false;
	public domainPackageViewConfig = ListForIntegrationsViewConfig;

	constructor(
		public appService: AppService,
		public datasetRS: DatasetRecordService,
		public datasetACS: DatasetActionContainerService,
		protected datasetNavigatorService: DatasetNavigatorService,
		public datasetService: DatasetService,
		private dialog: MatDialog
	){}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes.tourOperator){
			this.websiteFormData = {
				publish_on_web: changes.tourOperator.currentValue.active,
				website_export_disabled: !Boolean(changes.tourOperator.currentValue.website_export_enabled)
			};
		}
	}

	ngOnInit(): void{}

	createTripPackageIntegration(): void{
		this.create.emit();
	}

	integrationUpdated(integration: any): void{
		this.updated.emit(integration);
	}
	
	widgetOptions(formViewerService: FormViewerService) {
		const formValues = formViewerService.getFormData();
		this.reload.emit({
			widget_entity_customer_id: formValues['entity_customer.entity_customer_id'],
			selectedWidgetColor: formValues['widget_color'],
			widgetType: formValues['widget_type']
		});
	}
	
	openWidgetDialog(): void {
		this.dialog.open(WidgetDialogComponent, {
			width: '80%',
			height: '80%',
			data: { snippet: this.tourOperator.snippet }
		});
	}

	onWebsiteFormChanges($event){
		console.log('onWebsiteFormChanges', $event);
	}
}